import React, { useEffect, useState } from 'react';
import './SubscriptionPlan.scss';
import { FxInput, FxDate, http, AlertService, formValidator, FxSelect, formatService, FxDateDisplay } from '../../../fx-core';
import * as _ from 'lodash';
import { Button } from '@material-ui/core';
import useRazorpay from '../../../utils/useRazorPay';

const SubscriptionPlan = (props) => {
  const Razorpay = useRazorpay();

  const defaultItem = {
    subscriptionPlanId: -1,
    startDate: "",
    endDate: "",
    amount: 0,
    subscriptionPaymentMode: "-1",
    stallId: props.stallId,
    userId: props.userId,
    id: props.subscriptionId > 0 ? props.subscriptionId : 0,
    couponCode: "",
    paymentStatus: "Pending",
  };
  const defaultSubscription = {
    subscriptionPlan: "",
    startDate: "",
    endDate: "",
    id: 0
  };
  const [item, setItem] = useState(defaultItem);
  const [subscriptionPlans, setSubscriptionPlans] = useState([]);
  const [paymentOptions, setPaymentOptions] = useState([]);
  const [errors, setErrors] = useState({});
  const [currentStep, setCurrentStep] = useState(1);
  const [subscription, setSubscription] = useState(defaultSubscription);
  const [remainingAmount, setRemainingAmount] = useState(0);
  const [couponApplied, setCouponApplied] = useState(false);
  const [originalAmount, setOriginalAmount] = useState(0);
  const [couponDiscount, setCouponDiscount] = useState(0);

  // Normalize to midnight for day-level compare
  const startOfDay = (d: any) => { const dt = new Date(d); dt.setHours(0, 0, 0, 0); return dt; };
  const isBeforeToday = (d: any) => startOfDay(d) < startOfDay(new Date());

  const validateCoupon = async (couponCode) => {
 try {
    let apiOptions = {
      url: `coupon/validate`,
      data: {
        couponCode: couponCode,
        FeatureCouponType:  1,
        amount: item.amount
      }
    };
    
    const response = await http.post(apiOptions);
    
    // Check if coupon is valid
    if (response.data && response.data.isValid) {
      return true; // ✅ Valid coupon
    } 
  } catch (error) {
    // Show specific error message from backend
    return false; // ❌ Error = invalid
  }
  };
const applyCoupon = async () => {
  if (!item.couponCode) {
    AlertService.showErrorMsg("Please enter coupon code");
    return;
  }

  try {
    let tempItem = {
      ...item,
      subscriptionPaymentMode: 'coupon',
      startDate: formatService.getCurrentDateForServer()
    };

    let apiOptions = {
      url: `providersubscription/save/payments`,
      data: tempItem
    };
    console.log("Applying coupon with request:", apiOptions.data);

    const response = await http.post(apiOptions);
    const remainingAmt = response.data.remainingAmount || 0;
    const discount = response.data.discountAmount || 0;
    const isFullCoupon = response.data.isFullCoupon || false;

    console.log("Coupon Response:", {
      originalAmount: item.amount,
      discountAmount: discount,
      remainingAmount: remainingAmt,
      isFullCoupon: isFullCoupon
    });

    // Store original amount
    setOriginalAmount(item.amount);
    setCouponDiscount(discount);
    setRemainingAmount(remainingAmt);
    setCouponApplied(true);

    // Show appropriate message
    if (remainingAmt <= 0 || isFullCoupon) {
      AlertService.showSuccessMsg(`Full coupon applied! ₹${discount} discount. No payment required.`);
    } else {
      AlertService.showSuccessMsg(`Coupon applied! ₹${discount} discount. Remaining: ₹${remainingAmt}`);
    }

    // Update item state
    setItem(prevState => ({
      ...prevState,
      amount: remainingAmt,
      // Only reset payment mode if there's remaining amount to pay
      subscriptionPaymentMode: remainingAmt > 0 ? '-1' : 'coupon'
    }));
    
  } catch (error) {
    console.error("Coupon error:", error);
    AlertService.showErrorMsg("Invalid coupon code or coupon already used");
    // Reset states on error
    setCouponApplied(false);
    setRemainingAmount(0);
    setCouponDiscount(0);
    setOriginalAmount(0);
  }
};

const removeCoupon = () => {
  console.log("Removing coupon, original amount:", originalAmount);
  
  const originalAmt = originalAmount || item.amount;
  
  // Reset all coupon states first
  setCouponApplied(false);
  setRemainingAmount(0);
  setCouponDiscount(0);
  setOriginalAmount(0);
  
  // Reset item to original state
  setItem(prevState => ({
    ...prevState,
    couponCode: "",
    subscriptionPaymentMode: "-1",
    amount: originalAmt
  }));
  
  AlertService.showSuccessMsg("Coupon removed");
};
  const getFilteredPaymentOptions = () => {
    let filtered = paymentOptions.filter(option => option.code !== 'coupon');

    if (couponApplied && remainingAmount > 0) {
      filtered = filtered.filter(option =>
        option.code === 'razorpay' || option.code === 'accounttransfer'
      );
    }

    return filtered;
  };

  const initLookup = () => {
    let inputData = {
      lookups: {
        SubscriptionPlans: { default: true },
        PaymentMode: { default: true }
      },
      filters: {}
    };
    let apiOptions = {
      url: 'options/lookup',
      data: inputData
    };

    http.post(apiOptions).then(res => {
      const result = res.data;
      const plans = (result.SubscriptionPlans || []).filter(p => p.id !== -1);
      setSubscriptionPlans(plans);

      if (plans.length === 1) {
        const only = plans[0];
        handleItemChange({ subscriptionPlanId: only.id });
        getPlanDetailsByPlanId(only.id);
      }

      setPaymentOptions(result.PaymentMode);
    });

    getSubscriptionByStallId();
  }

  const handleInputChange = (data) => {
    handleItemChange({ [data.name]: data.value });
    data.validations = getInputValidations(data.name);
    const validationResult = formValidator.validate(data);
    const validationData = { [data.name]: validationResult };
    updateErrors(validationData);

    if (data.name == "subscriptionPlanId" && data.value > 0) {
      getPlanDetailsByPlanId(data.value);
    } else if (data.name === "startDate") {
      if (data.value && isBeforeToday(data.value)) {
        AlertService.showErrorMsg("Start Date cannot be earlier than today.");
        const today: any = formatService.getCurrentDateForServer
          ? formatService.getCurrentDateForServer()
          : new Date();

        handleItemChange({ startDate: today });
        loadEndDate(today, item.subscriptionPlanId);
        return;
      }
      loadEndDate(data.value, item.subscriptionPlanId);
    }
  }

  const handleItemChange = (data) => {
    setItem(prevState => {
      return { ...prevState, ...data }
    });
  };

  const getSubscriptionDetailsById = () => {
    let apiOptions: any = {
      url: `providersubscription/${props.subscriptionId}`
    };
    http.get(apiOptions).then(res => {
      const result = res.data;
      setItem(result);
    })
  }

  const getSubscriptionByStallId = () => {
    let inputData = {
      currentDate: formatService.getCurrentDateForServer(),
      stallId: item.stallId
    };
    let apiOptions: any = {
      url: `providersubscription/stall`,
      data: inputData
    };
    http.post(apiOptions).then(res => {
      const result = res.data;
      if (result && result.subscription != null) {
        setSubscription(result.subscription);
        setCurrentStep(2);
      }
    })
  }

  const validationMap_Item = {
    subscriptionPlanId: ["select"],
    startDate: ["required"],
    subscriptionPaymentMode: ["select"]
  };

  const getValidations = () => {
    let validationMap;
    validationMap = validationMap_Item;
    return validationMap;
  }

  const getInputValidations = (name) => {
    let validationMap = getValidations();
    return validationMap[name];
  }

  const bulkValidate = () => {
    let items: any = [];
    let validationMap = getValidations();
    for (var key in validationMap) {
      let result = { name: key, value: item[key], validations: validationMap[key] }
      items.push(result);
    }
    let validationResult = formValidator.bulkValidate(items);
    updateErrors(validationResult.errors);
    return validationResult.isValid;
  }

  const updateErrors = (validationData) => {
    setErrors(prevState => {
      return { ...prevState, ...validationData }
    });
  }

  const hasError = (field, validationMethod) => {
    return (
      errors &&
      errors[field] &&
      errors[field][validationMethod]
    );
  };

  const getPlanDetailsByPlanId = (planId) => {
    let apiOptions: any = {
      url: `subscriptionplan/${planId}`
    };
    http.get(apiOptions).then(res => {
      const result = res.data;
      let itemObj = {
        amount: result.amount
      };
      handleItemChange(itemObj);
      loadEndDate(item.startDate, planId);
    })
  }

  const loadEndDate = (startDate, planId) => {
    if (startDate) {
      let computedEndDate = computeEndDate(startDate, planId);
      handleItemChange({ endDate: computedEndDate });
    }
  }

  const computeEndDate = (startDate: any, planId: any) => {
    let endDate: any = null;
    let lookupItem: any = _.find(subscriptionPlans, { id: planId });
    if (lookupItem.code == 'Monthly') {
      endDate = formatService.getMonthEndDate(startDate);
    }
    else if (lookupItem.code == 'Yearly') {
      endDate = formatService.getYearEndDate(startDate);
    }
    return endDate;
  }

const saveSubscription = () => {
  const isValid = bulkValidate();
  if (isValid) {
    let saveItem = { ...item };
    saveItem.startDate = formatService.getDateStringForServer(saveItem.startDate);
    
    // Handle full coupon case
    if (couponApplied && remainingAmount <= 0) {
      saveItem.amount = 0;
      saveItem.subscriptionPaymentMode = "coupon"; // This is crucial!
    }

    if (couponApplied && remainingAmount > 0) {
      saveItem.amount = remainingAmount;
    }

    let apiOptions: any = {
      url: `providersubscription/save/payments`,
      data: saveItem
    };

    console.log("Save Subscription Request:", apiOptions.data);

    http.post(apiOptions).then(res => {
      saveSubscriptionCallBack(res);
    }).catch(error => {
      console.error("Save subscription error:", error);
      AlertService.showErrorMsg("Failed to save Onboarding Charges. Please try again.");
    });
  }
};

const saveSubscriptionCallBack = (res) => {
  console.log("Save Subscription Response:", res.data);
  let provSubscriptionId = res.data ? res.data.provSubscriptionId : 0;
  let isFullCoupon = res.data ? res.data.isFullCoupon : false;
  let remainingAmt = res.data ? res.data.remainingAmount : 0;

  setRemainingAmount(remainingAmt);

  AlertService.showSuccessMsg();

  if (provSubscriptionId > 0) {
    // Handle full coupon case
    if (isFullCoupon === true || (couponApplied && remainingAmt <= 0)) {
      AlertService.showSuccessMsg("Onboarding completed with full coupon discount!");
      
      // Important: Add a small delay to ensure state updates
      setTimeout(() => {
        navBackToReqContainer(provSubscriptionId);
      }, 100);
      
      // Reset states
      setCouponApplied(false);
      setRemainingAmount(0);
      setCouponDiscount(0);
      setOriginalAmount(0);
      
    } else if (item.subscriptionPaymentMode == 'razorpay' && item.paymentStatus == "Pending") {
      initiatePayment(provSubscriptionId);
    } else {
      navBackToReqContainer(provSubscriptionId);
    }
  }
};
const handleFullCouponCompletion = (subscriptionId) => {
  // Clear all coupon-related states
  setCouponApplied(false);
  setRemainingAmount(0);
  setCouponDiscount(0);
  setOriginalAmount(0);
  
  // Reset item
  setItem({
    ...defaultItem,
    stallId: props.stallId,
    userId: props.userId
  });
  
  // Navigate back
  navBackToReqContainer(subscriptionId);
};

  const navBackToReqContainer = (id) => {
    props.onSubscriptionCallback(id);
  }

  const initiatePayment = (provSubscriptionId) => {
    let inputData = {
      entityTypeId: 1,
      entityId: provSubscriptionId
    };
    let apiOptions: any = {
      url: `payment/GetPaymentLink`,
      data: inputData
    };
    http.post(apiOptions).then(res => {
      openPaymentLink(res, provSubscriptionId);
    });
  }

  const openPaymentLink = (resp: any, provSubscriptionId: any) => {
    var item = resp.data.result;
    let checkoutIdentifier = item.checkoutIdentifier;
    let externalOrderId = item.externalOrderId;
    let amount = item.amount;
    let description = item.description;
    let customerName = item.providerName;
    let email = item.email;
    let mobile = item.mobile;

    const options: any = {
      amount: amount,
      description: description,
      order_id: externalOrderId,
      handler: async function (response: any) {
        let data: any = {
          Id: item.id,
          ExternalPaymentId: response.razorpay_payment_id,
          ExternalOrderId: externalOrderId
        };
        await updateRazorPaySuccess(data);
        AlertService.showSuccessMsg("Payment Success!");
        navBackToReqContainer(provSubscriptionId);
      },
      prefill: {
        name: customerName,
        email: email,
        contact: mobile
      }
    };

    const rzp1 = new Razorpay(options);
    rzp1.on("payment.failed", function (response: any) {
      console.log("payment failed, response=", response);
    });

    rzp1.open();
  }

  const updateRazorPaySuccess = async (inputData) => {
    let apiOptions: any = {
      url: `payment/updatePaymentSuccess`,
      data: inputData
    };
    await http.post(apiOptions);
  }

  const navigateBack = () => {
    navBackToReqContainer(0);
  }

  const navigateNext = () => {
    navBackToReqContainer(subscription.id);
  }

  useEffect(() => {
    initLookup();
  }, []);

  return (
    <div className='subscriptionplan-ui'>
      <div className='row justify-content-center pt-5 font-18 text-bold'>Onboarding Charges</div>
      <div className='row justify-content-center pt-5 font-18 text-bold'>Onetime Fee 7999/- + GST </div>

      {currentStep == 1 &&
        <div className='row p-3 justify-content-center'>
          <div className='col-xs-12 col-md-8 p-3'>
            <FxInput name="amount" variant="outlined" fullWidth size="small" label="Original Amount"
              value={item.amount || ""} disabled onValueChange={handleInputChange} />

            {/* Coupon Discount Breakdown */}
            {couponApplied && (
              <div className="coupon-info mt-2 p-3 border rounded bg-light">
                <div className="row">
                  <div className="col-6">
                    <strong>Original Amount:</strong>
                  </div>
                  <div className="col-6 text-right">
                    ₹{originalAmount}
                  </div>
                </div>
                <div className="row text-success">
                  <div className="col-6">
                    <strong>Coupon Discount:</strong>
                  </div>
                  <div className="col-6 text-right">
                    - ₹{couponDiscount}
                  </div>
                </div>
                <hr />
                <div className="row text-warning">
                  <div className="col-6">
                    <strong>Remaining Amount:</strong>
                  </div>
                  <div className="col-6 text-right">
                    <strong>₹{remainingAmount}</strong>
                  </div>
                </div>
                {remainingAmount <= 0 && (
                  <div className="row text-success mt-2">
                    <div className="col-12 text-center">
                      <strong>Full amount covered by coupon!</strong>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Coupon Code Input */}
        <div className='col-xs-12 col-md-8 p-3'>
  <div className="row">
    <div className="col-9">
      <FxInput
        name="couponCode"
        variant="outlined"
        label="Coupon Code"
        fullWidth
        size="small"
        value={item.couponCode || ""}
        onValueChange={handleInputChange}
        disabled={couponApplied}
      />
    </div>
    
    <div className="col-3">
      {!couponApplied ? (
        <Button
          variant="contained"
          color="primary"
          onClick={applyCoupon}
          disabled={!item.couponCode || item.couponCode.trim() === ""}
          fullWidth
        >
          Apply
        </Button>
      ) : (
        <Button
          variant="contained"
          color="secondary"
          onClick={removeCoupon}
          fullWidth
        >
          Remove
        </Button>
      )}
    </div>
  </div>
</div>

          <div className='col-xs-12 col-md-8 p-3'>
            <FxDate name="startDate" variant="outlined" size="small" fullWidth label="Start Date"
              value={item.startDate} onValueChange={handleInputChange}
              minDate={formatService.getCurrentDateForServer()}
              disablePast />
            {hasError("startDate", "required") && <div className="error">Start Date is required</div>}
          </div>

          {/* Payment Method - Only show if remaining amount > 0 */}
          {(!couponApplied || remainingAmount > 0) && (
            <div className='col-xs-12 col-md-8 p-3'>
              <FxSelect
                name="subscriptionPaymentMode"
                variant="outlined"
                label={couponApplied && remainingAmount > 0 ? "Select Payment for Remaining Amount" : "Select Payment"}
                disabled={item.paymentStatus === "Paid"}
                options={getFilteredPaymentOptions()}
                selectedValue={item.subscriptionPaymentMode}
                valueField="code"
                displayField="text"
                size="small"
                onValueChange={handleInputChange}
              />
              {hasError("subscriptionPaymentMode", "select") && (
                <div className="error row">Payment is required</div>
              )}

              {couponApplied && remainingAmount > 0 && (
                <div className="text-info mt-1 small">
                  Only Bank Transfer and Credit/Debit card available for remaining amount payment
                </div>
              )}
            </div>
          )}

          {/* Full Coupon Message */}
      {/* In the JSX return */}
{couponApplied && remainingAmount <= 0 && (
  <div className='col-xs-12 col-md-8 p-3'>
    <div className="alert alert-success text-center">
      <strong>✓ Full amount covered by coupon!</strong>
      <br />
      <small>Click "Save" below to complete your subscription. No payment required.</small>
    </div>
    <div className="text-center mt-2">
      <FxInput
        name="subscriptionPaymentMode"
        type="hidden"
        value="coupon"
      />
    </div>
  </div>
)}
          {/* Bank Transfer Details */}
          {item.subscriptionPaymentMode == "accounttransfer" && (
            <div className='col-xs-12 col-md-8 pt-1'>
              <div className="border p-3 bg-light">
                <h6>Bank Transfer Details:</h6>
                <div>A/C No: 66661236660</div>
                <div>Company Name: AUTHY HYPERLOCAL PRIVATE LIMITED</div>
                <div>IFSC: IDFB0080531</div>
                <div>Bank name: IDFC FIRST</div>
                <div>Branch: Coimbatore Branch</div>
                {couponApplied && remainingAmount > 0 && (
                  <div className='mt-2 text-danger font-weight-bold'>
                    Transfer Amount: ₹{remainingAmount}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Credit/Debit Card Info */}
          {item.subscriptionPaymentMode == "razorpay" && couponApplied && remainingAmount > 0 && (
            <div className='col-xs-12 col-md-8 pt-1'>
              <div className="border p-3 bg-light">
                <h6>Credit/Debit Card Payment:</h6>
                <div className='text-success font-weight-bold'>
                  Payment Amount: ₹{remainingAmount}
                </div>
              </div>
            </div>
          )}
        </div>
      }

      {/* Step 2 UI */}
      {currentStep == 2 &&
        <div className='row p-3 pt-5 justify-content-center'>
          <div className='col-xs-12 col-md-8 p-3'>
            <span><b>Subscription Plan Name: </b></span>
            <span>{subscription.subscriptionPlan}</span>
          </div>
          <div className='col-xs-12 col-md-8 p-3'>
            <span><b>Start Date: </b></span>
            <span> <FxDateDisplay value={subscription.startDate} /></span>
          </div>
          <div className='col-xs-12 col-md-8 p-3'>
            <span><b>End Date: </b></span>
            <span><FxDateDisplay value={subscription.endDate} /></span>
          </div>
          <div className='col-xs-12 col-md-8 p-3'>
            <span><b>Status: </b></span>
            <span>Active</span>
          </div>
        </div>
      }

      <div className='row justify-content-center pb-3'>
        {currentStep == 1 &&
          <div>
            <span className='pr-2'><Button variant="contained" size="medium" onClick={navigateBack}> Back </Button></span>
            <Button variant="contained" size="medium" color="primary" onClick={saveSubscription}> Save </Button>
          </div>
        }
        {currentStep == 2 &&
          <div>
            <span className='pr-2'><Button variant="contained" size="medium" onClick={navigateBack}> Back </Button></span>
            <Button variant="contained" size="medium" color="primary" onClick={navigateNext}> Next </Button>
          </div>
        }
      </div>
    </div>
  );
}
export default SubscriptionPlan;